<template>
  <!-- Add -->
  <b-modal
    id="modaltype"
    ref="my-modal"
    title="แก้ไขเหตุการณ์"
    ok-title="ตกลง"
    cancel-title="ยกเลิก"
    @ok="editType"
  >
    <b-row>
      <!-- First name -->
      <b-col cols="12">
        <b-form-group
          v-slot="{ ariaDescribedby }"
        >
          <b-form-radio-group
            id="radio-slots"
            v-model="selected"
            :options="itemsType"
            value-field="id"
            text-field="iname"
            :aria-describedby="ariaDescribedby"
            name="radio-options-slots"
            stacked
          />
        </b-form-group>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import axios from '@axios'
import {
  BRow, BCol, BFormGroup, BFormRadioGroup,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormRadioGroup,
  },
  data() {
    return {
      itemsType: [],
      selected: '',
      id: '',
    }
  },
  mounted() {
    this.dropdownType()
  },
  methods: {
    getID(value) {
      this.id = value
    },
    async editType() {
      axios
        .post('https://khuntan-api.hwpd.go.th/editIncident-Type', { id: this.id, incident_type: this.selected })
        .then(() => {
          this.$swal({
            icon: 'success',
            title: '<span style="color:#000000">แก้ไขข้อมูลเรียบร้อย</span>',
            showConfirmButton: false,
            timer: 1000,
          })
          this.$emit('fetch')
        })
        .catch(error => {
          console.log(error)
        })
    },
    dropdownType() {
      axios
        .post('https://khuntan-api.hwpd.go.th/incident-Type')
        .then(response => {
          this.itemsType = response.data
        })
    },
  },
}
</script>
